import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsMatrixODModel {
  id: string;
  address: string;
  name: string;
  cameraType: string;
  status: string;
  description: string;
  title: string;
  icon: Icon;
  markerPopupText: string;
  coordinates : any[]
}

export class MatrixODModel extends MarkerModelBase {
  static className = 'MatrixODModel';
  classProperties: IPropsMatrixODModel;

  constructor(props: IPropsMatrixODModel, geometry: IGeometryModel) {
    super(geometry, MatrixODModel.className);
    this.classProperties = props;

  }
}
